
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Gamepad2 } from "lucide-react";

interface MentorGamesBadgesProps {
  games: { id: string; name: string }[];
  maxDisplay?: number;
}

export const MentorGamesBadges: React.FC<MentorGamesBadgesProps> = ({ 
  games, 
  maxDisplay = 3 
}) => {
  // Make sure games is an array, even if it's null/undefined
  const safeGames = Array.isArray(games) ? games : [];

  if (safeGames.length === 0) {
    return (
      <Badge 
        variant="outline" 
        className="bg-[#1E293B] text-gray-300 border-[#2D3748] px-2 py-1 flex items-center gap-1"
      >
        <Gamepad2 className="h-3 w-3" />
        Mentor disponível
      </Badge>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {safeGames.slice(0, maxDisplay).map((game) => (
        <Badge 
          key={game.id}
          variant="outline" 
          className="bg-[#1E293B] text-gray-300 border-[#2D3748] px-2 py-1 flex items-center gap-1"
        >
          <Gamepad2 className="h-3 w-3" />
          {game.name}
        </Badge>
      ))}
      {safeGames.length > maxDisplay && (
        <Badge variant="outline" className="bg-[#1E293B] text-gray-300 border-[#2D3748]">
          +{safeGames.length - maxDisplay}
        </Badge>
      )}
    </div>
  );
};
